var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2771_7167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 36C28.4411 36 36.5 27.9411 36.5 18C36.5 8.05888 28.4411 0 18.5 0C8.55888 0 0.5 8.05888 0.5 18C0.5 27.9411 8.55888 36 18.5 36Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0959 13.9946C17.0959 13.1486 17.7889 12.8156 18.9409 12.8156C20.5969 12.8156 22.6849 13.3196 24.3409 14.2106V9.09861C22.5319 8.37861 20.7499 8.09961 18.9499 8.09961C14.5309 8.09961 11.5969 10.4036 11.5969 14.2556C11.5969 20.2586 19.8679 19.3046 19.8679 21.8966C19.8679 22.8956 18.9949 23.2196 17.7799 23.2196C15.9709 23.2196 13.6669 22.4816 11.8399 21.4826V26.6576C13.8649 27.5306 15.9079 27.8996 17.7799 27.8996C22.3069 27.8996 25.4209 25.6586 25.4209 21.7616C25.3849 15.2816 17.0959 16.4336 17.0959 13.9946Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2771_7167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.041aa82bbc31f7465abd343d2f0dff89.svg";
export { ForwardRef as ReactComponent };